import React, { useState } from 'react';
import styles from './RelatedMediaFormSection.module.scss';
import { inject } from 'mobx-react';
import { PROJECT_STORE } from 'store';
import { Button, ObjectsPopupSelector, ProjectsTable } from 'components';
import { observer } from 'mobx-react-lite';
import LabeledFormSectionContainer from '../LabeledFormSectionContainer';

const RelatedMediaFormSection = props => {
  const {
    [PROJECT_STORE]: {
      getVovProjects,
      vovProjectList
    },
    selectedProjectsList,
    setSelectedProjectsList
  } = props;

  const [showPopup, setShowPopup] = useState(false);

  const handleManageRelatedMediaClick = () => {
    getVovProjects();
    setShowPopup(true);
  };

  return (
    <LabeledFormSectionContainer label='Related Media'>

      {!!selectedProjectsList.length &&
        <ProjectsTable
          projectsList={selectedProjectsList}
          flatTable
          setProjectList={setSelectedProjectsList}
        />
      }

      <Button
        type='add'
        size='small'
        onClick={handleManageRelatedMediaClick}
        className={styles.manageProjectsBttn}
      >
        Manage Related Media
      </Button>

      {showPopup &&
        <ObjectsPopupSelector
          title='Manage Related Media'
          onClose={() => setShowPopup(false)}
          objectsList={vovProjectList}
          selectedObjectsList={selectedProjectsList}
          setSelectedList={setSelectedProjectsList}
        />
      }

    </LabeledFormSectionContainer>
  );
};

export default inject(PROJECT_STORE)(observer(RelatedMediaFormSection));
